import { t } from 'i18next';

import {
  OnboardingCard,
  OnboardingExplainer,
  SecondaryText,
  SettingsPageLink,
} from '../CompanyOnboardingPrimitives';

interface StepSectionCardProps {
  copyKey: string;
  link: string;
  testId: string;
}

const StepSectionCard = ({ copyKey, link, testId }: StepSectionCardProps) => (
  <OnboardingCard data-test-id={testId} sx={{ mt: 1.5, p: 2 }}>
    <OnboardingExplainer copyKey={copyKey} />
    <SecondaryText sx={{ mt: 0.5 }}>{t(`${copyKey}.most`)}</SecondaryText>
    <SettingsPageLink data-test-id={`${testId}-open`} settingsLink={link}>
      {t(`${copyKey}.open`)}
    </SettingsPageLink>
  </OnboardingCard>
);

export default StepSectionCard;
